import { GivelifyButton, GivelifyLabel } from '@givelify/givelify-ui';
import { GivelifyNotification } from '@givelify/ui';
import { styled } from '@mui/material/styles';

export const StyledNotification = styled(GivelifyNotification)({
    marginBottom: 40,
});

export const StyledHeader = styled(GivelifyLabel)({
    textAlign: 'center',
    marginBottom: 16,
});

export const StyledSubheader = styled(GivelifyLabel)(({ theme }) => ({
    marginBottom: 32,
    [theme.breakpoints.up('sm')]: {
        textAlign: 'center',
    },
}));

export const ControlsWrapper = styled('div')({
    display: 'grid',
    gap: 16,
    gridTemplateColumns: '1fr 1fr auto',
    borderRadius: 4,
    backgroundColor: 'rgba(246, 246, 246, 0.8)',
    padding: 8,
    marginBottom: 16,
    marginLeft: -16,
    marginRight: -16,
});

export const StyledSearchButton = styled(GivelifyButton)(({ theme }) => ({
    borderRadius: 4,
    width: 56,
    height: 56,
    [theme.breakpoints.down('sm')]: {
        width: 40,
        height: 40,
        minWidth: 40,
        minHeight: 40,
    },
}));

export const DetailsWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 32,
});

export const ListWrapper = styled('div')({
    display: 'grid',
    gap: 16,
    gridTemplateColumns: 'repeat(auto-fill, minmax(248px, 1fr))',
    gridAutoRows: '1fr',
});

export const CampusListItemWrapper = styled('div')(({ theme }) => ({
    border: '1px solid #E3E3E3',
    borderRadius: 10,
    boxShadow: '0px 0px 8px rgba(131, 131, 131, 0.3)',
    padding: '24px 16px 16px',
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    [theme.breakpoints.up('md')]: {
        flexDirection: 'column',
    },
    '&:hover': {
        border: `1px solid ${theme.legacy.colors.neutralGrey75}`,
        cursor: 'pointer',
    },
}));

export const ListItemText = styled('div')({
    flex: 1,
});

export const ListItemHeader = styled('div')({
    marginBottom: 8,
});

export const ListItemAction = styled('div')(({ theme }) => ({
    alignSelf: 'center',
    [theme.breakpoints.up('md')]: {
        marginTop: 32,
        alignSelf: 'end',
    },
}));

export const StyledChip = styled('div')(({ theme }) => ({
    backgroundColor: '#DCF1E5',
    borderRadius: 20,
    padding: theme.spacing('3px', '8px'),
    color: theme.legacy.colors.neutralGrey,
}));

export const CantFindListItem = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 16,
    border: '1px dashed #E3E3E3',
    borderRadius: 10,
});

export const LocationSelect = styled('div')({
    height: 48,
    backgroundColor: 'white',
});
